export default import.meta.ROLLDOWN_FILE_URL_2qsgISSs7gg5PPxNsWY0nA